import { authenticatedFetch } from './request';

export default async function fetchAuthenticatedUser() {
    return await authenticatedFetch('/auth/whoami');
}
